import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getUsersApiClient } from "@shared/apis/sidekick/api-factories";
import { buildGetUsersQueryKey } from "./useGetUsers";
import { buildGetUserQueryKey } from "./useGetUser";
import { toast } from "@shared/services/toast";

type Props = {
  onSuccess?: () => void;
};

type Params = {
  userId: string;
};

export const useDisableUser = (props?: Props) => {
  const { onSuccess } = props || {};
  const api = getUsersApiClient();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: async (params: Params) => {
      const response = await api.userControllerDisableUser({
        userId: params.userId,
      });
      queryClient.invalidateQueries({ queryKey: buildGetUsersQueryKey() });
      queryClient.invalidateQueries({
        queryKey: buildGetUserQueryKey(params.userId),
      });
      onSuccess?.();
      toast.success("User has been disabled successfully");
      return response;
    },
    onError: (error, { userId }) => {
      console.error(`Failed to disable user with ID: ${userId}`, error);
    },
  });

  return mutation;
};
